export default "__VITE_ASSET__yOCebtty__"